import React from "react";
import m from "../../images/9.png";
import o from "../../images/0.jpg";
import star from "../../images/star.svg";
import not from "../../images/notification.svg";
import swift from "../../images/swift-logo.png";
import o1 from "../../images/ree.jpeg";

export default function Meet() {
  return (
    <div>
    <div className="lazyload-wrapper">
      <div className="m">
        <div className=" m1">
          <div className="lazyload-wrapper">
            <div className="m2">
              <div
                
                className=" m3"
              ></div>
              <div
            
                className="m4"
              ></div>
              <div
            
                className="m5"
              ></div>
              <div className="m6">
                <div className=" m7"></div>
                <div className="m8"></div>
              </div>
              <div
               
                className="m9"
              ></div>
              <div
               
                className="m10"
              ></div>
              
            </div>
          </div>
        </div>
        <div className="m12">
          <p className="m13">Who is behind</p>
          <h2 className="m14"> Testimonial</h2>
          <p className="m15">
          I am delighted to share my experience with Aara Clouds as a customer. Their services have truly exceeded my expectations .


          </p>
        </div>
        <div className="m16">
        
          <div className="m17">
            <div className=" m18">
              <div className=" m19">
                <div className="m20">
                  <div className="lazyloader-wrapper">
                    <img alt="" src={o} className=" mm" />
                  </div>
                  <p class="mm1"> Per Larsson</p>
                  <p class=" text-black">sampletekk.com</p>
                  <p class=" mm3">
                  I am delighted to share my experience
                  </p>
                  <div class="mm4">
                    {/* <div>
                      <div class=" mm5">
                        <img src={star} alt="icon" />
                      </div>
                    </div>
                    <div>
                      <img src={not} alt="Twitter handle" class=" mm6" />
                    </div> */}
                  </div>
                </div>
              </div>

              <div class=" hXsmLs">
                <p class="mm8">Hosting User</p>
                <div class="mm9">
                  <div class=" mmm">
                    <div class="mmm1">
                      <img src={swift} alt="course logo" class=" sw" />
                    </div>
                    <div class="mk">
                      <p class=" mk1">
                      I am delighted to share my experience
                      </p>
                      <p class="mk2">
                      The customer support provided by Aara Clouds has also been exceptional. Whenever I've had questions or encountered any technical issues, their support team has been responsive, knowledgeable, and eager to assist. 
                      </p>
                    </div>
                  </div>
                  <div class=" mmm">
                    <div class="mmm1">
                      <img src={swift} alt="course logo" class=" sw" />
                    </div>
                    <div class="mk">
                      <p class=" mk1">
                      I am delighted to share my experience
                      </p>
                      <p class="mk2">
                      Their expertise and prompt resolution of any concerns have truly impressed me and have made my hosting experience stress-free.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="m17">
            <div className=" m18">
              <div className=" m19">
                <div className="m20">
                  <div className="lazyloader-wrapper">
                    <img alt="" src={o1} className=" mm" />
                  </div>
                  <p class="mm1">nabeel perfumes</p>
                 <p>Dubai</p>
                  <p class=" mm3">
                  I am delighted to share my experience
                  </p>
                  <div class="mm4">
                    {/* <div>
                      <div class=" mm5">
                        <img src={star} alt="icon" />
                      </div>
                    </div>
                    <div>
                      <img src={not} alt="Twitter handle" class=" mm6" />
                    </div> */}
                  </div>
                </div>
              </div>

              <div class=" hXsmLs">
                <p class="mm8">Hosting User</p>
                <div class="mm9">
                  <div class=" mmm">
                    <div class="mmm1">
                      <img src={swift} alt="course logo" class=" sw" />
                    </div>
                    <div class="mk">
                      <p class=" mk1">
                      I am delighted to share my experience
                      </p>
                      <p class="mk2">
                      I would also like to highlight the user-friendly interface and intuitive control panel provided by [Web Hosting Website]. Managing my website, setting up domains,
                      </p>
                    </div>
                  </div>
                  <div class=" mmm">
                    <div class="mmm1">
                      <img src={swift} alt="course logo" class=" sw" />
                    </div>
                    <div class="mk">
                      <p class=" mk1">
                      I am delighted to share my experience
                      </p>
                      <p class="mk2">
                      thanks to their well-designed control panel. It has made the entire process seamless and convenient, even for someone with limited technical knowledge.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  );
}
